import { render, staticRenderFns } from "./PlantaoHistory.vue?vue&type=template&id=ba133078&scoped=true"
import script from "./PlantaoHistory.vue?vue&type=script&lang=js"
export * from "./PlantaoHistory.vue?vue&type=script&lang=js"
import style0 from "./PlantaoHistory.vue?vue&type=style&index=0&id=ba133078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba133078",
  null
  
)

export default component.exports